import React, { useState, useContext, useEffect, useRef } from 'react';
import { Card } from 'react-bootstrap';
import DealContext from '../DealContext';
import ApiService from '../../../services/ApiService';

const DealDescCard = () => {
  const [editDesc, setEditDesc] = useState(false);
  const editDescRef = useRef(null);

  const { deal } = useContext(DealContext);

  const [desc, setDesc] = useState(deal.description || '');

  const updateDesc = () => {
    ApiService.put(`db/EQS2/${deal.id}`, { description: desc }).then(response => {
      setDesc(desc);
      setEditDesc(false);
    });
  };

  useEffect(() => {
    if (editDesc) {
      setTimeout(() => {
        if (editDescRef.current) {
          editDescRef.current.select();
        }
      }, 10);
    }
  }, [editDesc]);

  return (
    <Card>
      <div className="card-toolbar">
        {editDesc === true ? (
          <>
            <div className="card-toolbar-button" title="Accept" onClick={updateDesc}>
              <i style={{ color: 'var(--green-5)' }} className="fas fa-check fa-fw" />
            </div>
            <div className="card-toolbar-button" title="Cancel" onClick={() => setEditDesc(false)}>
              <i style={{ color: 'var(--red-5)' }} className="fas fa-times fa-fw" />
            </div>
          </>
        ) : (
          <div className="card-toolbar-button" onClick={() => setEditDesc(true)}>
            <i className="fas fa-pen fa-fw" />
          </div>
        )}
      </div>
      <Card.Body>
        <Card.Title>Description</Card.Title>
        {editDesc === true ? (
          <textarea value={desc} onChange={e => setDesc(e.target.value)} ref={editDescRef} maxLength="175" />
        ) : (
          <Card.Text onDoubleClick={() => setEditDesc(true)}>{desc || 'No Description Set'}</Card.Text>
        )}
      </Card.Body>
    </Card>
  );
};

export default DealDescCard;
